import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import reduxLink from '../../functions/reduxLink'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-jalaali'
import { lazyLoadHandler } from '../../functions/lazyLoad'
import EmptyTableContent from '../error/EmptyTableContent'
import TableSkeleton from '../skeleton/tableSkeleton'

function SmsTable({ sms, lazy_load_data, setLazyLoadData, setSms, is_all_items_load, setAllLoad }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const showMore = (id) => {
    const link = 'sms'
    reduxLink(link, dispatch)
    navigate(`/${link}/${id}`)
  }

  const getTableDataLazyLoad = async (obj_data) => {
    await lazyLoadHandler(
      `admin/sms`,
      'sms',
      sms,
      10,
      lazy_load_data,
      setLazyLoadData,
      obj_data,
      is_all_items_load,
      setAllLoad,
      setSms
    )
  }

  return (
    <div
      className="relative rounded-2xl border border-light-gray dark:border-gray-700 max-h-[450px] overflow-auto scroll-smooth bg-table-thead"
      onScroll={getTableDataLazyLoad}
    >
      {sms?.length > 0 ? (
        <table className="w-full text-sm text-right bg-table-thead dark:bg-slate-800 relative whitespace-nowrap">
          <thead className="text-md bg-table-thead dark:bg-slate-800 sticky top-0 w-full">
            <tr className={'border-b border-b-light-gray dark:border-b-gray-700'}>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                ردیف
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                گیرندگان (دسته بندی)
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                تاریخ
              </th>
              <th scope="col" className="px-6 py-4 dark:text-amber-100">
                عملیات
              </th>
            </tr>
          </thead>

          <tbody className={'text-md bg-light-blue dark:bg-slate-800'}>
            {sms?.map((sms, index) => {
              return !sms ? (
                <TableSkeleton key={index} index={index} count={4} />
              ) : (
                <tr key={sms.id} className="border-b border-b-light-gray dark:border-b-gray-700">
                  <td className="px-6 py-4 dark:text-amber-50">{index + 1}</td>
                  <td className="px-6 py-4 w-fit flex dark:text-amber-50">
                    {sms?.['receivers'].join('-')}
                  </td>
                  <td className="px-6 py-4 dark:text-amber-50">
                    {moment(sms?.created_at).format('jYYYY/jMM/jDD')}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => showMore(sms.id)}
                      className="font-medium text-link dark:text-link hover:underline"
                    >
                      مشاهده
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      ) : (
        <EmptyTableContent text={'پیامک ثبت نشده است.'} />
      )}
    </div>
  )
}

export default memo(SmsTable)
